<template>
  <div id="app">
    <el-container>
      <el-header height="auto">
        <div class="header">
          <div class="logobar" @click="handleSelect('home')" v-if="systemSettings.sitelogo">
            <img :src="systemSettings.sitelogo" class="logo" :alt="systemSettings.sitename">
          </div>

          <!-- 移动端菜单按钮 -->
          <div class="mobile-menu-toggle" @click="toggleMobileMenu" v-if="isMobile">
            <i class="el-icon-menu"></i>
          </div>

          <!-- 桌面端菜单 -->
          <div class="menubar" v-if="!isMobile">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item index="home">首页</el-menu-item>
              <el-menu-item index="about">关于我们</el-menu-item>
              <el-menu-item index="products">产品中心</el-menu-item>
              <el-menu-item index="news">新闻资讯</el-menu-item>
              <el-menu-item index="join">招聘信息</el-menu-item>
              <el-menu-item index="contact">联系我们</el-menu-item>
            </el-menu>
          </div>

          <!-- 移动端菜单弹层 -->
          <div class="mobile-menu-overlay" v-if="showMobileMenu && isMobile">
            <div class="mobile-menu-content">
              <div class="mobile-menu-header">
                <div class="mobile-logo">
                  <img :src="systemSettings.sitelogo" class="mobile-logo-img" :alt="systemSettings.sitename">
                </div>
                <div class="close-btn" @click="toggleMobileMenu">×</div>
              </div>
              <el-menu :default-active="activeIndex" class="mobile-menu-list" mode="vertical"
                @select="handleMobileSelect">
                <el-menu-item index="home">首页</el-menu-item>
                <el-menu-item index="about">关于我们</el-menu-item>
                <el-menu-item index="products">产品中心</el-menu-item>
                <el-menu-item index="news">新闻资讯</el-menu-item>
                <el-menu-item index="join">招聘信息</el-menu-item>
                <el-menu-item index="contact">联系我们</el-menu-item>
              </el-menu>
            </div>
          </div>
        </div>
      </el-header>

      <el-main>
        <!-- 使用keep-alive缓存页面组件状态 -->
        <keep-alive include="Home,About,Products,News,Join,Contact">
          <router-view />
        </keep-alive>
      </el-main>

      <el-footer height="auto">
        <div class="footer">
          <el-row>
            <el-col :span="16" :class="{ 'mobile-col': isMobile }">
              <div><img src="@/assets/footer_logo.png" class="footerlogo"></img></div>
              <div v-html="systemSettings.sitefootinfo"></div>
              <div><a class="links_ygwa"
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41019702004457" rel="noreferrer"
                  target="_blank">豫公网安备41019702004457号</a></div>
            </el-col>
            <el-col :span="8" class="footerqr" :class="{ 'mobile-col': isMobile }">
              <div class="qrimg"><img :src="systemSettings.sitefootqrcodeimg" class="footerqrcode"></img><br />{{
                systemSettings.sitefootqrcodetext }}</div>
            </el-col>
          </el-row>
        </div>
      </el-footer>
      <div class="totop" v-if="showgotop"><span @click="gototop()"><i class="el-icon-top"></i></span></div>
    </el-container>
  </div>
</template>

<script>
import { productApi, systemApi } from '@/api'
export default {
  name: 'App',
  data() {
    return {
      activeIndex: 'home',
      showgotop: false,
      systemSettings: {}, // 存储系统设置信息
      showMobileMenu: false, // 控制移动端菜单显示
      isMobile: false // 是否为移动设备
    }
  },
  created() {
    this.checkDeviceType();
  },
  mounted() {
    // 根据当前路由设置菜单激活状态
    this.setActiveMenuByRoute();
    // 获取系统设置信息
    this.fetchSystemSettings();
    // 监听页面滚动事件
    window.addEventListener('scroll', this.handleScroll);
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 组件销毁前移除滚动事件监听器
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    $route(to) {
      // 根据路由更新菜单激活状态
      this.setActiveMenuByRoute();
    }
  },
  methods: {
    // 检测设备类型
    checkDeviceType() {
      this.isMobile = window.innerWidth <= 768;
    },

    // 处理窗口大小变化
    handleResize() {
      this.checkDeviceType();
      if (!this.isMobile) {
        this.showMobileMenu = false;
      }
    },

    // 切换移动端菜单显示
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },

    // 处理移动端菜单选择
    handleMobileSelect(key) {
      this.handleSelect(key);
      this.showMobileMenu = false;
    },

    // 获取系统设置信息
    async fetchSystemSettings() {
      try {
        const response = await systemApi.getSystemSettings();
        this.systemSettings = response.data;
        this.$store.dispatch('setSystemSettings', response.data);
        // 动态更新meta标签
        this.updateMetaTags();
      } catch (error) {
        console.error('获取系统设置失败:', error);
      }
    },
    // 动态更新meta标签
    updateMetaTags() {
      // 更新keywords meta标签
      let keywordsMeta = document.querySelector('meta[name="keywords"]');
      if (keywordsMeta) {
        keywordsMeta.setAttribute('content', this.systemSettings.sitekeyword || '');
      }

      // 更新description meta标签
      let descriptionMeta = document.querySelector('meta[name="description"]');
      if (descriptionMeta) {
        descriptionMeta.setAttribute('content', this.systemSettings.sitedes || '');
      }

    },
    setActiveMenuByRoute() {
      // 根据当前路由设置菜单激活状态
      if (this.$route.name === 'Home') {
        this.activeIndex = 'home'
      } else if (this.$route.name === 'About') {
        this.activeIndex = 'about'
      } else if (this.$route.name === 'Products') {
        this.activeIndex = 'products'
      } else if (this.$route.name === 'News') {
        this.activeIndex = 'news'
      } else if (this.$route.name === 'Contact') {
        this.activeIndex = 'contact'
      } else if (this.$route.name === 'Join') {
        this.activeIndex = 'join'
      }
    },
    handleSelect(key) {
      switch (key) {
        case 'home':
          this.$router.push('/')
          break
        case 'about':
          this.$router.push('/about')
          break
        case 'products':
          this.$router.push('/products')
          break
        case 'news':
          this.$router.push('/news')
          break
        case 'contact':
          this.$router.push('/contact')
          break
        case 'join':
          this.$router.push('/join')
          break
      }
    },
    handleScroll() {
      // 获取页面滚动的高度
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 获取页面总高度
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      );
      // 获取浏览器窗口高度
      const windowHeight = window.innerHeight;

      // 如果滚动高度加上窗口高度接近文档总高度，说明滚动到底部
      if (scrollTop + windowHeight >= documentHeight - 100) { // 100px的容差
        this.showgotop = true;
      } else {
        this.showgotop = false;
      }
    },
    gototop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, PingFang SC, Hiragino Sans GB, Microsoft Yahei, STHeiti, SimSun,
    sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol,
    Noto Color Emoji;
  color: #313131;
}

* {
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  min-height: 100vh;

  .el-header {
    padding: 0;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 333;
    box-shadow: 0 0 5px #ccc;

    .el-menu {
      display: inline-block;
      border-bottom: none;

      .el-menu-item {
        color: #000;
        border-bottom: none;

        &:hover,
        &.is-active {
          color: #D32442;
        }

        &.is-active::after {
          display: block;
          content: "";
          width: 100%;
          height: 4px;
          border-radius: 2px;
          background: #D32442;
        }
      }
    }
  }

  .mainwrap {

    // background: url(assets/homebg1.jpg) no-repeat center top #fff;
    // background-size: cover;
  }

  .textCenter {
    text-align: center;
  }

  .subbanner {
    height: 300px;
    width: 100%;
    background-color: #eee;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    color: #fff;
    text-shadow: -1px -1px 1px #313131;

    .container {
      padding-left: 100px;
    }

    .title {
      font-size: 38px;
      letter-spacing: 0px;
      line-height: 32px;
      margin: 20px 0 20px 0;
    }

    span {
      position: relative;
      font-size: 22px;
      font-family: 'Times New Roman', Times, serif;
    }
  }

  .submain {
    padding: 20px 0 50px 0;

    img {
      max-width: 80%;
    }
  }

  .titleA {
    position: relative;
    font-size: 30px;
    font-weight: bold;
    margin: 20px 0;
    padding: 0;
    color: #000;
    text-indent: 20px;
    ;
  }

  .titleA strong::after {
    display: block;
    content: "";
    width: 6px;
    border-radius: 4px;
    height: 30px;
    background: #D32442;
    position: absolute;
    left: 0;
    top: 10px;
  }

  .el-button--primary {
    background: #D32442;
    border-color: #D32442;
  }

  .el-button--primary:hover {
    background: #ae112b;
    transition: all 0.5s ease-in-out;
  }

  .el-header {
    background: #fff;

    .header {
      width: 1200px;
      height: 88px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .mobile-menu-toggle {
        display: none;
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0.5rem;
      }
    }

    .logobar {
      flex: 1;
    }

    .menubar {
      flex: 2;
      text-align: right;
    }

    .logo {
      cursor: pointer;
      width: 180px;
    }
  }

  .el-main {
    width: 100%;
    padding: 0;

    .container {
      width: 1200px;
      margin: 0 auto;
    }
  }

  .el-footer {
    height: auto !important;
    min-height: 20px;
    padding: 60px 0;
    background: #004DB8;
  }

  .footer {
    width: 1200px;
    margin: 0 auto;
    color: #fff;
    font-size: 14px;
    line-height: 2;

    .links_ygwa {
      position: relative;
      color: #fff;
      text-decoration: none;
      padding-left:25px;
    }

    .links_ygwa:before {
      position: absolute;
      left: 0;
      top: -1px;
      content: "";
      display: inline-block;
      width: 20px;
      height: 23px;
      background: url(assets/icon-gongan.png) no-repeat;
    }

    .footerlogo {
      width: 180px;
    }

    .footerqr {
      text-align: right;

      .qrimg {
        display: inline-block;
        text-align: center;
      }
    }

    .footerqrcode {
      width: 120px;
      background: #fff;
      padding: 4px;
    }
  }
}

.totop {
  position: fixed;
  right: 20px;
  bottom: 20px;

  span {
    cursor: pointer;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    font-weight: bold;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    color: #004DB8;
  }
}

// 移动端适配样式
@media (max-width: 768px) {
  #app {
    .el-header {
      .header {
        width: 100%;
        padding: 0 1rem;
        height: auto;
        min-height: 60px;
        align-items: center;

        .mobile-menu-toggle {
          display: block;
        }

        .logobar {
          flex: 1;
        }

        .menubar {
          display: none;
        }
      }

      .logo {
        width: 120px;
        max-height: 40px;
      }
    }

    .container {
      width: 100% !important;
      padding: 0 1rem;
      box-sizing: border-box;
    }

    .el-main {
      padding: 0;
    }

    .subbanner {
      height: 18rem;
      ;
      background-size: auto;

      .container {
        padding-left: 2rem !important;
      }

      .title {
        font-size: 1.5rem;
      }

      span {
        font-size: 1.1rem;
      }
    }

    .footer {
      width: 100%;
      padding: 1rem;
      font-size: 0.8rem;

      .el-col-16 {
        width: 100%;
        text-align: center;
      }

      .footerlogo {
        width: 120px;
      }

      .footerqr {
        width: 100%;
        margin-top: 1rem;
        text-align: center;
      }

      .footerqrcode {
        width: 80px;
        height: 80px;
      }
    }

    .submain {
      img {
        max-width: 100%;
        ;
      }
    }

    .home {
      .banner {

        .banner-text {
          margin-left: 1rem !important;

          h2 {
            font-size: 1.8rem !important;
          }

          h5 {
            font-size: 1.2rem !important;
          }
        }
      }

      .homeAbout {
        padding: 2rem 1rem !important;

        .container {
          flex-direction: column !important;
          text-align: center !important;
        }

        .left,
        .right {
          width: 100% !important;
          margin-bottom: 1rem;
          display: flex;
          justify-content: center;
        }

        .mid {
          width: 100% !important;
          padding: 1rem 0 !important;

          h2 {
            font-size: 1.5rem !important;
          }
        }
      }

      .midbanner {
        padding: 1.5rem 1rem !important;

        .piclist {
          width: 100% !important;

          .picli {
            width: 100% !important;
            margin: 0 0 1rem 0 !important;

            &:last-child {
              margin-bottom: 0 !important;
            }
          }
        }
      }

      .homejoin {
        padding: 2rem 1rem !important;

        h2 {
          font-size: 1.5rem !important;
        }
      }
    }

    .products {
      .procat {
        ul {
          padding: 0.5rem;

          li {
            display: block !important;
            margin: 0 0 0.5rem 0 !important;
            padding: 0.8rem !important;

            &:last-child {
              margin: 0 !important;
            }
          }
        }
      }

      .pro-item {
        div {
          width: 100% !important;
          display: block !important;
          margin-bottom: 1rem;
        }
      }
    }

    .news-list {
      .news-item {
        padding: 1rem !important;

        h3 {
          font-size: 1rem !important;
        }

        .news-date {
          font-size: 0.8rem !important;
        }
      }
    }

    .titleA {
      font-size: 1.2rem;
    }

    .titleA strong::after {
      top: 0.3rem;
      height: 1.2rem;
    }
  }

  // 移动端菜单覆盖层
  .mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 1000;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;

    .mobile-menu-content {
      width: 80%;
      max-width: 300px;
      height: 100%;
      background: #fff;
      display: flex;
      flex-direction: column;
      box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);

      .mobile-menu-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem;
        border-bottom: 1px solid #eee;

        .mobile-logo {
          flex: 1;

          .mobile-logo-img {
            max-height: 40px;
            max-width: 120px;
          }
        }

        .close-btn {
          font-size: 2rem;
          cursor: pointer;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .mobile-menu-list {
        flex: 1;
        border: none;
        margin-top: 1rem;

        .el-menu-item {
          height: auto;
          line-height: 2.5rem;
          padding: 0.3rem 1rem !important;
        }
      }
    }
  }

  .totop {
    right: 1rem;
    bottom: 1rem;

    span {
      width: 40px;
      height: 40px;
      font-size: 1.5rem;
    }
  }
}
</style>